import type { CSSObject } from '@emotion/react';
import { keyframes } from '@mui/material/styles';

import { type Theme, useTheme } from '../../../../theme';

type InputStyles = Record<'inputCharacterCountPulseRedCSS', CSSObject>;

const fadePulseRed = (theme: Theme): string => keyframes`
  0% {
    color: ${theme.text.generic.tertiary};
  }
  50% {
    color: ${theme.text.generic.negative};
  }
  100% {
    color: ${theme.text.generic.tertiary};
  }
`;

export const useFormMessageStyles = (): InputStyles => {
  const theme = useTheme();

  return {
    inputCharacterCountPulseRedCSS: {
      animation: `${fadePulseRed(theme)} 1s ${
        theme.transitions.easing.easeInOut
      }`,
    },
  };
};
